import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { BlogPostPage } from "@/pages/BlogPostPage";
import { getPostBySlug, postPath } from "@/lib/blog-posts";
import { buildBlogHead } from "./blog.$slug_.$post";

// /blog/<theme>/<post>. A post belongs to exactly one theme; a wrong theme in
// the URL 301s to the right one.
export const Route = createFileRoute("/en/blog/$slug_/$post")({
  loader: ({ params }) => {
    const post = getPostBySlug(params.post);
    if (!post) throw notFound();
    if (post.theme !== params.slug) {
      throw redirect({ href: `/en${postPath(post)}`, statusCode: 301 });
    }
    return { post };
  },
  head: ({ params }) => buildBlogHead(params?.post, "en"),
  component: BlogPostRoute,
  notFoundComponent: () => (
    <div className="mx-auto max-w-2xl px-6 pt-40 pb-32 text-center">
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-display text-5xl">Post not found</h1>
      <a
        href="/en/blog"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-foreground px-6 py-3 text-xs font-medium uppercase tracking-[0.22em] text-background"
      >
        To the journal →
      </a>
    </div>
  ),
});

function BlogPostRoute() {
  const { post } = Route.useLoaderData();
  return <BlogPostPage post={post} locale="en" />;
}
